import type { WatchdogData } from 'service/watchdog/model.ts';
import { getLocalityName } from 'utils/getLocalityName.ts';
import { price } from 'utils/format.tsx';
import { localize } from 'i18n/localize.ts';

const $t = localize();

export const WATCHDOG_ITEM_OPTIONS = [
	{ id: 'edit', icon: 'edit' },
	{ id: 'delete', icon: 'delete' },
] as const;

export function getWatchdogInfoLine(watchdog: WatchdogData) {
	const children = [];

	const { locality, priceTo, priceForFree, priceFrom, radiusPrecision } = watchdog.filter;

	children.push(
		<span>
			v {locality ? getLocalityName(locality) : $t.watchdog.inEntireCzechia}
			{locality && !!radiusPrecision && ` (+${radiusPrecision} km)`}
		</span>,
	);

	if (priceTo && priceFrom) {
		children.push(
			<>
				{$t.filters.from} {price(priceFrom)} {$t.filters.To.toLowerCase()} {price(priceTo)}
			</>,
		);
	} else if (priceTo) {
		children.push(
			<>
				{$t.filters.to} {price(priceTo)}
			</>,
		);
	} else if (priceFrom) {
		children.push(
			<>
				{$t.filters.from} {price(priceFrom)}
			</>,
		);
	} else if (priceForFree) {
		children.push($t.filters.forFree.toLowerCase());
	} else {
		children.push($t.filters.noLimit.toLowerCase());
	}

	if (!watchdog.filter.hidePriceByAgreement) {
		children.push(`(${$t.filters.includingAgreement})`);
	}

	return children.flatMap((child) => [child, ' ']);
}
